import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { Icons, Images } from "assets";
import classNames from "classnames";
import moment from "moment";
import styles from "pages/phNewAccountsDetail/style.module.scss";
import React from "react";
import { useNavigate } from "react-router-dom";
import useWindowSize from "shared/customHooks/windowSize";
import { routeConstant } from "shared/routes/routesConstant";
import { monthly_plans } from "shared/utils/constants";

const plan_types = {
  regular: 1,
  promotional: 2,
};

function Parent({ usersLoader, users, handleOpenConfirm }: any) {
  const screenWidth = useWindowSize();
  const navigate = useNavigate();

  console.log("users", users);

  return (
    <TableContainer
      component={Paper}
      sx={screenWidth > 990 ? { width: `${screenWidth - 350}px` } : {}}
      className={classNames(
        !users?.length ? styles.noDataContainer : styles.tableContainer
      )}
      id="table-view-dashboard"
    >
      <Table>
        <TableHead className={styles.tableHead}>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Linked Accounts (Kids)</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Phone</TableCell>
            <TableCell>Joining Date</TableCell>
            <TableCell>Membership</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody className={styles.tableBody}>
          {usersLoader ? (
            <Loader />
          ) : (
            users?.map((item: any, index: number, arr: any[]) => {
              return (
                <TableRow
                  className={classNames(
                    index + 1 === arr?.length && styles.noBorder
                  )}
                >
                  <TableCell
                    sx={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={
                        item?.parent?.profile_picture
                          ? item?.parent?.profile_picture
                          : Images.UserPlaceholderImage
                      }
                      alt="profile_picture"
                      className={styles.profilepic}
                    />
                    <label>{item?.parent?.full_name}</label>
                  </TableCell>
                  <TableCell>{item?.total_kids}</TableCell>
                  <TableCell>{item?.email}</TableCell>
                  <TableCell>
                    {item?.parent?.phone ? item?.parent?.phone : "Not Provided"}
                  </TableCell>
                  <TableCell>
                    {moment(item?.created_at).format("DD MMM, YYYY")}
                  </TableCell>
                  <TableCell className={styles.biggerCell}>
                    {!item?.current_plan
                      ? "No Subscription"
                      : item?.current_plan?.type === plan_types?.regular
                      ? "Regular "
                      : item?.current_plan?.type === plan_types?.promotional
                      ? "Promotional "
                      : "Not Provided"}

                    {item?.current_plan && (
                      <>
                        (
                        {
                          monthly_plans?.find(
                            (itm: any) => itm?.value === item?.current_plan?.duration
                          )?.label
                        }
                        )
                      </>
                    )}
                  </TableCell>
                  <TableCell>
                    <div className={styles.actionContainer}>
                      <Tooltip
                        componentsProps={{
                          tooltip: { className: "tooltip" },
                          arrow: { className: "arrow" },
                        }}
                        placement="top"
                        arrow
                        title="View"
                      >
                        <div
                          // onClick={() => {
                          //   navigate(
                          //     routeConstant.userProfile.path
                          //       .replace(":role", "parent")
                          //       .replace(":id", "1")
                          //   );
                          // }}
                        >
                          <Icons.EyeIcon />
                        </div>
                      </Tooltip>

                      <Tooltip
                        componentsProps={{
                          tooltip: { className: "tooltip" },
                          arrow: { className: "arrow" },
                        }}
                        placement="top"
                        arrow
                        title={!item?.is_blocked ? "Deactivate" : "Activate"}
                      >
                        <div
                          onClick={() =>
                            handleOpenConfirm(
                              `Are you sure, you want to ${
                                item?.is_blocked ? "activate" : "deactivate"
                              } this user?`,
                              `${item?.is_blocked ? "activate" : "deactivate"}`,
                              item
                            )
                          }
                        >
                          {!item?.is_blocked ? (
                            <Icons.UserDeactivate
                              className={classNames(
                                styles.icons,
                                styles.deactive
                              )}
                            />
                          ) : (
                            <Icons.UserActivate
                              className={classNames(
                                styles.icons,
                                styles.active
                              )}
                            />
                          )}
                        </div>
                      </Tooltip>
                    </div>
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default Parent;

const Loader = () => {
  return (
    <React.Fragment>
      {Array.from({ length: 8 }).map((item, index) => {
        return (
          <TableRow key={index} id={styles.loaderRow}>
            <TableCell>
              <div
                style={{ display: "flex", gap: "8px", alignItems: "center" }}
              >
                <Skeleton variant="circular" width={40} height={40} />
                <Skeleton variant="rounded" width={100} height={25} />
              </div>
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={120} height={25} />
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={30} height={25} />
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={40} height={25} />
            </TableCell>
            <TableCell className={styles.actionCell}>
              <Skeleton variant="rounded" width={130} height={25} />
            </TableCell>
            <TableCell className={styles.actionCell}>
              <Skeleton variant="rounded" width={130} height={25} />
            </TableCell>
            <TableCell
              className={classNames(styles.actionCell, styles.biggerCell)}
            >
              <Skeleton variant="rounded" width={130} height={25} />
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={40} height={25} />
            </TableCell>
            <TableCell>
              <div
                style={{ display: "flex", gap: "8px", alignItems: "center" }}
              >
                <Skeleton variant="rounded" width={25} height={25} />
                <Skeleton variant="rounded" width={25} height={25} />
              </div>
            </TableCell>
          </TableRow>
        );
      })}
    </React.Fragment>
  );
};
